import { type Clinic, getClinics } from '@snootsvet/shared'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/frontend/components/ui/table'
import { useDocumentTitle } from '@/frontend/hooks/use-document-title'

function ClinicsTable({ clinics }: { clinics: Clinic[] }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Address</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {clinics.map((clinic) => (
          <TableRow key={clinic.id}>
            <TableCell className="font-medium">{clinic.name}</TableCell>
            <TableCell className="text-muted-foreground">{clinic.address}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export function ClinicsAdminPage() {
  useDocumentTitle('Clinics')
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-headline-lg">Clinics</h1>
      </div>
      <ClinicsTable clinics={getClinics({ includeArchived: true })} />
    </div>
  )
}
